<template>
    <v-app-bar id="core-app-bar" absolute app color="grey lighten-1" flat height="75">
        <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
            <v-btn icon @click="$store.commit('setDrawer', !$store.getters.drawer)">
                <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
        </v-toolbar-title>

        <v-spacer />

        <v-toolbar-items>
            <v-row align="center" class="mx-0" >
                <v-menu offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn v-on="on" icon>
                            <v-icon color="tertiary">
                                mdi-account
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title @click="logout()">Logout</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-row>
        </v-toolbar-items>
    </v-app-bar>
</template>

<script>
import bus from '../nav/bus'
export default {
    methods: {
        show() {
            console.log(this.$store.getters.drawer)
        },
        logout(){
            console.log('logout')
            bus.$emit('alert', {msg: 'Log out successfully', title: "Hint",　check: "Got it"})
            this.$router.push('/login')
        }
    }
}
</script>

<style>
  /* Fix coming in v2.0.8 */
  #core-app-bar {
    width: auto;
  }

  #core-app-bar a {
    text-decoration: none;
  }
</style>
